import {
  CustomElement,
  CustomText,
} from "../../../admin/components/RichTextEditor/RichTextEditor.types";
import { Element, Descendant } from "slate";

const serializeText = (node: CustomText): string => {
  let text = node.text || "";

  if (node.bold && node.italic) {
    text = `***${text}***`; // bold + italic together
  } else if (node.bold) {
    text = `**${text}**`;
  } else if (node.italic) {
    text = `*${text}*`;
  }

  if (node.underline) {
    text = `__${text}__`;
  }

  if (node.strikethrough) {
    text = `~~${text}~~`;
  }

  return text;
};

export const slateToMarkdown = (nodes: Descendant[]): string => {
  return nodes
    .map((node) => {
      if (!Element.isElement(node)) {
        // ✅ Format text only here
        return serializeText(node);
      }

      const childrenText = node.children
        .map((child) =>
          Element.isElement(child)
            ? slateToMarkdown([child])
            : serializeText(child) // ✅ Format only leafs
        )
        .join("");

      switch (node.type) {
        case "paragraph":
          return `${childrenText}\n\n`;
        case "block-quote":
          return `> ${childrenText}\n\n`;
        case "bulleted-list":
          return node.children
            .map((child) => {
              const listItemText = Element.isElement(child)
                ? slateToMarkdown(child.children).trim()
                : serializeText(child);
              return listItemText.trim() ? `- ${listItemText}` : "";
            })
            .filter(Boolean) // Remove empty strings
            .join("\n") + "\n\n";
        case "numbered-list":
          return node.children
            .map((child, i) => {
              const listItemText = Element.isElement(child)
                ? slateToMarkdown(child.children).trim()
                : serializeText(child);
              return listItemText.trim() ? `${i + 1}. ${listItemText}` : "";
            })
            .filter(Boolean) // Remove empty strings
            .join("\n") + "\n\n";
        case "list-item":
          return childrenText.trim();
        case "link":
         // return `[${children}](${node.url})`;
         const linkText = childrenText.trim();
         return linkText ? `[${linkText}](${node.url})` : "";
       // return `[${node.children.map(child => slateToMarkdown([child])).join("")}](${node.url})`;
        default:
          return childrenText;
      }
    })
    .join("");
};
